import React, { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { MfeLoad } from '@carvana/microfrontend';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import DropdownArrow from '@Shared/DropdownArrow';
import Button from '@Shared/MenuButton';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { selectPartner } from '@Header/ducks/selectors';
import { getContentServiceRequestId, getMobileSupportMenuState, getScreenWidth } from '../../SupportDropdown/ducks/selectors';
import * as supportDropdownOperations from '../../SupportDropdown/ducks/operations';

const StyledButton = styled(Button)`
  color: ${props => props.theme.carvana.white.primary};
  font-size: 10px;
  text-align: center;
`;

const StyledArrowDropDown = styled(DropdownArrow)`
  fill: ${props => props.theme.carvana.white.primary};
  width: 13px;
`;

class Support extends PureComponent {
  static contextType = AnalyticsContext;

  static propTypes = {
    toggleMobileSupportMenuDropdownState: PropTypes.func.isRequired,
    contentServiceRequestId: PropTypes.string.isRequired,
    isMobileSupportMenuOpen: PropTypes.bool.isRequired,
    screenWidth: PropTypes.number.isRequired,
    hasPartner: PropTypes.bool.isRequired
  };

  handleDrawerToggle = (eventName, assignedBucket) => {
    const {
      toggleMobileSupportMenuDropdownState,
      contentServiceRequestId,
      isMobileSupportMenuOpen,
    } = this.props;
    if (eventName !== '') {
      const { trackEvent } = this.context;
      trackEvent('user platform - header - expanded support & contact menu', { platform: 'mobile' });
    }

    MfeLoad({
      files: [
        [
          'CoreSupportDropdown',
          [
            {
              component: 'default',
              default: {
                file: 'index.js',
                manifest: process.env.CVNA_APP_SDD_URL,
              },
            },
          ],
        ],
      ],
    });
    toggleMobileSupportMenuDropdownState(!isMobileSupportMenuOpen);
  };

  shouldShowP2PSSD = () => {
    try {
      const shouldShowP2P = !IsServerSideRendering && window.location.href.includes('vehicles/community/');
      return shouldShowP2P;
    } catch (e) {
      console.log(e);
      return true;
    }
  };

  render() {
    const { isMobileSupportMenuOpen, screenWidth, hasPartner } = this.props;
    const shouldSpaceOutCopyText = screenWidth <= 320 && hasPartner;

    return (
      <Fragment>
        <StyledButton
          dataCvTest="headerMobileSupportMenu"
          onClick={() =>
            this.handleDrawerToggle(
              'Header - Support - Expanded Support Drop-Down'
            )
          }
          disableHref
        >
          <div>Support {shouldSpaceOutCopyText && <br />} & Contact</div>
          <StyledArrowDropDown />
        </StyledButton>

        {isMobileSupportMenuOpen &&
        <MfeReactComponent
          module="CoreSupportDropdown"
          component="default"
          isOpen={isMobileSupportMenuOpen}
          closeModal={this.handleDrawerToggle}
        />
        }
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  contentServiceRequestId: getContentServiceRequestId(state),
  isMobileSupportMenuOpen: getMobileSupportMenuState(state),
  screenWidth: getScreenWidth(state),
  hasPartner: selectPartner(state).partnerId !== 1
});

const mapDispatchToProps = {
  toggleMobileSupportMenuDropdownState:
    supportDropdownOperations.toggleMobileSupportMenuDropdownState,
  closeMobileSupportMenu: supportDropdownOperations.closeSupportDropdown,
};

export default connect(mapStateToProps, mapDispatchToProps)(Support);
